import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MediaSkeletonComponent } from '@shared/media';
import { MediaRatioSkeleton } from '@shared/media/models/media.models';

const DEFAULT_ITEMS = 6;
const DEFAULT_RATIO: MediaRatioSkeleton = '3-4';

@Component({
    selector: 'related-products-skeleton',
    templateUrl: './related-products-skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MediaSkeletonComponent,
    ],
})
export class RelatedProductsSkeletonComponent {
    public readonly items = input<number>(DEFAULT_ITEMS);

    public readonly ratio = input<MediaRatioSkeleton>(DEFAULT_RATIO);

    public readonly itemsArray = Array.from({ length: this.items() });
}
